import React from "react";
import images from "../../../Assets/images";

// types
import { ButtonProps } from "./Button.types";

// css
import "./style.css";

const index = (props: ButtonProps) => {
  const {
    varient,
    buttonLabel,
    buttonIcon,
    size,
    handleClick,
    disabled,
    className,
    type,

    ...rest
  } = props;

  return (
    <button
      type={type || "button"}
      className={`${varient} ${size} ${className}`}
      onClick={handleClick}
      disabled={disabled}
      {...rest}
    >
      {buttonLabel}
      {buttonIcon}
    </button>
  );
};

export default index;
